(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import ScrollToTop from '../components/scroll-to-top';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import ListGalleryExterior from '../components/list-gallery-exterior';
import '../assets/styles/components/Floorplans.scss';
import '../assets/styles/components/Gallery.scss';

function importAll(r) {
  const images = {};
  r.keys().forEach((item, index) => {
    const module = r(item);
    images[item.replace('./', '')] = module.__esModule ? module.default : module;
  });
  return images;
}

let imagesgallery;
let imagesgallerylarge;

if (typeof window !== 'undefined') {
  imagesgallery = importAll(require.context('../assets/static/gallery/exterior', false, /\.(png|jpe?g|svg)$/));
  imagesgallerylarge = importAll(require.context('../assets/static/gallery/exterior/large', false, /\.(png|jpe?g|svg)$/));
} else {
  const requireContext = require('require-context');

  imagesgallery = importAll(requireContext('../../src/frontend/assets/static/gallery/exterior', false, /\.(png|jpe?g|svg)$/));
  imagesgallerylarge = importAll(requireContext('../../src/frontend/assets/static/gallery/exterior/large', false, /\.(png|jpe?g|svg)$/));
}

class Gallery extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Gallery"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "GALLERY THE DISTRICT, check out our Exterior Amenities pictures. Enjoy THE DISTRICT."
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, {
      mode: "nobg"
    }), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "gallery"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Gallery The District"))), /*#__PURE__*/React.createElement(Container, {
      className: "content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 mb-5 biglinehd"
    }, /*#__PURE__*/React.createElement("span", null, "Exterior Amenities")), /*#__PURE__*/React.createElement("div", {
      className: "list-group list-group-horizontal text-center"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/gallery",
      className: "active list-group-item list-group-item-action list-group-item-secondary"
    }, "Exterior Amenities"), /*#__PURE__*/React.createElement(Link, {
      to: "/interior-features",
      className: "list-group-item list-group-item-action list-group-item-secondary"
    }, "Interior Features")), /*#__PURE__*/React.createElement(ListGalleryExterior, {
      listnormal: imagesgallery,
      listlarge: imagesgallerylarge
    }))), /*#__PURE__*/React.createElement(Footer, null));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Gallery;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(importAll, "importAll", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/gallery.jsx");
  reactHotLoader.register(imagesgallery, "imagesgallery", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/gallery.jsx");
  reactHotLoader.register(imagesgallerylarge, "imagesgallerylarge", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/gallery.jsx");
  reactHotLoader.register(Gallery, "Gallery", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/gallery.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/gallery.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();